/**
 * This function checks if window.initDebugMode is set to a truthy value.
 * If so debug mode parameters are added to react habitat components, so that other system can read those information.
 * @param {string} argument
 * @return {string|undefined}
 */
export function debugModeArgument(argument) {
  if (window.initDebugMode) {
    return argument;
  }
}
